document.addEventListener('DOMContentLoaded', (): void => {
    const dialog = document.querySelector(
        'nh-modal[data-for="nh-stay-duration"], nh-modal[data-for="nh-stay-duration-detail-form"]'
    );

    dialog?.addEventListener('open', (): void => {
        const container = dialog.querySelector<HTMLElement>('.datepicker-calendar-modal-content');
        const currentMonthElement = dialog.querySelector<HTMLElement>(
            '.datepicker-calendar-current-month'
        );

        if (!container || !currentMonthElement) {
            return;
        }

        container.addEventListener('scroll', (): void => {
            const headers = document.querySelectorAll<HTMLElement>('.nh-calendar-month__header');
            let current = null;

            for (const header of headers) {
                if (container.scrollTop <= header.offsetTop) {
                    break;
                }

                current = header;
            }

            if (current) {
                currentMonthElement.style.opacity = '1';
                currentMonthElement.innerText = current.innerText;
                return;
            }

            currentMonthElement.style.opacity = '0';
        });
    });
});
